
<template>
  <div class="haibao-box">
    <van-swipe
      ref="swiper"
      class="kan"
      :width="auto"
      :touchable="indicators"
      :show-indicators="false"
      indicator-color="#DD2B1E"
      :loop="false"
      @change="onChange"
    >
      <van-swipe-item v-for="(item,i)  in items.poster" :key="i">
        <img
          style="width: 100%;height: 100%;"
          :src="item.picUrl"
          alt
          @touchstart="touchstart(item.picUrl)"
          @touchend="touchend()"
        />
        <div v-if="activition===i" class="showPop" @click="showPop()"></div>
      </van-swipe-item>
    </van-swipe>

    <div v-show="show" class="van-overlay">
      <div class="erCodeBOX" @touchstart="touchstart()" @touchend="touchend()">
        <vue-qr
          :text="items.url"
          :margin="0"
          colorDark="#000"
          colorLight="#fff"
          :logoSrc="items.logoUrl"
          :logoScale="0.2"
          :size="400"
          class="qrCodeStyle"
        ></vue-qr>
        <!-- <p class="bottomFont">微信扫码打开 或 长按保存至相册</p> -->
      </div>
      <img class="close" @click="closePop()" src="../img/ico_close.png" alt />
    </div>

    <div class="van-swipe__indicators" v-if="items.poster.length > 1">
      <i
        class="van-swipe__indicator"
        v-for="(item,i)  in items.poster"
        :key="i"
        :class="activition===i?'indicator':''"
      ></i>
    </div>
    <van-popup v-model="imageShow" position="bottom" :style="{ height: '20%'}">
      <van-button type="default" @click="saveImage()">保存图片</van-button>
      <van-button type="default" @click="cancelSaveImage()">取消</van-button>
    </van-popup>
    <div class="small-img-box">
      <div @click="qiehuan(i)" v-for="(item,i)  in items.poster" :key="i">
        <img
          :class="{  'activition':activition===i , 'activitionFour' : i==3 }"
          :src="item.picUrl"
          style="display: block"
          alt
        />
      </div>
    </div>
    <div>
      <div>
        <div v-if="items.shareContent">
          <p class="px ql-editor" v-html="items.shareContent"></p>
          <div class="btn" v-clipboard:copy="ToText(items.shareContent)" v-clipboard:success="onCopy">
            <img src="../img/ioco.png" alt /> 复制文案
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import getWXSign from "@/libs/wxSign";
// import wxShare from "@/libs/wxShare";
import vueQr from "vue-qr";

export default {
  name: "bill",
  data() {
    return {
      url: null,
      items: {
        poster: [],
        shareContent: "",
        url: "",
        logoUrl: ""
      },
      activition: 0,
      indicators: true,
      show: false,
      erCode: "",
      imageShow: false,
      dataUrl: "",
      channelType:"",
      memberId:"",
      isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    };
  },
  computed: {},
  components: {
    vueQr
  },
  filters: {},
  created() {
    this.channelType = JSON.parse(sessionStorage.getItem("user")).channelType;
    this.memberId = JSON.parse(sessionStorage.getItem("user")).memberId;
    if (this.$route.query.url)
    this.url = decodeURIComponent(this.$route.query.url);
    this.info();
    if (this.channelType == 'assistant') {
      this.setShareOpen();
    }
  },
  methods: {
    info() {
      this.$api
        .shareShow({
          // url: `${this.$route.query.url}&recordId=${this.$route.query.recordId}&channel=${this.$route.query.channel}&shareMemberId=${this.$route.query.shareMemberId}&sellType=${this.$route.query.sellType}&sellLabel=${this.$route.query.sellLabel}&saleMerchantId=${this.$route.query.saleMerchantId}&saleStoreId=${this.$route.query.saleStoreId}&assistantId=${this.$route.query.assistantId}&redirect=${this.$route.query.redirect}`
          url:this.url,
          memberId:this.memberId
        })
        .then(res => {
          this.items = res.data;
          let post = {
            skuNo:this.getUrlKey('skuNo'),
            recordId:this.getUrlKey('recordId'),
            channel:this.getUrlKey('channel'),
            shareMemberId:this.getUrlKey('shareMemberId'),
            sellType:this.getUrlKey('sellType'),
            sellLabel:this.getUrlKey('sellLabel'),
          };
          if(this.channelType == 'app'){
              this.$api.bargainShare(post).then(res => {
                const configData = res.data;
                let sharObj = { 
                shareLink:configData.shareUrl, 
                shareTitle:configData.title, 
                shareDescr:configData.subtitle, 
                shareImg:configData.picUrl, 
              }
              UnionDrugHealthy.showShareIcon(JSON.stringify(sharObj))
              });
          } 
          if(this.channelType == 'wechat') {
            getWXSign().then(jssdk => {
              this.$api.bargainShare(post).then(res => {
                const configData = res.data;
                jssdk.updateAppMessageShareData({
                  title: configData.title, // 分享标题
                  desc: configData.subtitle, // 分享描述
                  link: configData.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: configData.picUrl, // 分享图标
                });
              });
            });
          }
        });
    },
    //长按保存图片
    touchstart(picUrl) {
      if (sessionStorage.getItem("state") == "ydb" && !this.isiOS) {
        if (picUrl) {
          this.getBase64Image(picUrl);
        } else {
          this.dataUrl = this.erCode;
        }
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(() => {
          this.imageShow = true;
        }, 700);
      }
    },
    //清除定时器
    touchend() {
      clearInterval(this.Loop);
    },
    //图片保存
    saveImage() {
      this.$bs.downImage({ base64: this.dataUrl }).then(e => {
        if (e.msg) {
          this.$toast(e.msg);
        }
      });
      this.imageShow = false;
    },
    cancelSaveImage() {
      this.imageShow = false;
    },
    //  第一个参数是图片的URL地址，第二个是转换成base64地址后要赋值给的img标签
    getBase64Image(url) {
      let that = this;
      let image = new Image();
      image.crossOrigin = "*"; // 支持跨域图片
      image.src = url + "?v=" + Math.random(); // 处理缓存
      image.onload = function() {
        that.drawBase64Image(image);
      };
    },
    drawBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      this.dataUrl = canvas.toDataURL("image/png");
    },
    qiehuan(i) {
      console.log(i);
      this.activition = i;
      this.$refs.swiper.swipeTo(i);
    },
    onCopy() {
      this.$toast("复制成功！");
    },
    onChange(index) {
      this.activition = index;
    },
    showPop() {
      let oQrcode = document.querySelectorAll(".erCodeBOX img");
      this.erCode = oQrcode[0].src;
      this.show = true;
    },
    closePop() {
      this.show = false;
    },
    //显示分享按钮
    setShareOpen() {
      this.$api.invitation({}).then(res => {
        const configData = res.data;
        let shareDate = {
          shareLink: document.referrer,
          shareTitle: configData.title,
          shareDescr: "分享描述",
          shareImg: configData.picUrl,
          type: 0
        };
        this.$bs.serviceShare(shareDate).then(e => {
          // console.log('eee',e)
          if (e.status == "1") {
            this.$toast("分享成功");
          } else if (e.msg) {
            this.$toast(e.msg);
          }
        });
        this.$bs.setShareHidden({type:0}).then(e => {
          console.log("e", e);
          if (e.status == "1") {
            this.$toast("开启成功");
          } else if (e.msg) {
            this.$toast(e.msg);
          }
        });
      });
    },

    //隐藏分享按钮
    setShareHidden() {
      this.$bs.setShareHidden({ type: 1 }).then(e => {
        if (e.status == "1") {
          this.$toast("开启成功");
        } else if (e.msg) {
          this.$toast(e.msg);
        }
      });
    },
    getUrlKey(name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(this.items.url) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    ToText(HTML)
    {
      var input = HTML;
      return input.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/\s+/g,' ').replace(/ /g,' ').replace(/>/g,' ');  
    }
  },
  beforeDestroy() {
    this.setShareHidden();
  }
};
</script>

<style lang="scss" scoped>
.bg_text {
  display: flex;
  align-items: center;
  width: 100%;
  background: #fff;
  padding: 24px 20px;
  justify-content: space-between;
  box-sizing: border-box;
}

.bg_text_2 {
  display: flex;
}

.bg_text_2 .cp {
  color: #dd2b1e;
  width: 2rem;
}

.bg_text_2 .cp span {
  font-size: 36px;
}

.line {
  width: 2px;
  height: 60px;
  background: #e6e6e6;
}

.bg_text_1 {
  width: 60%;
}

.bg_text_1 .bg_text_1p {
  /*width: 100% !important;*/
  /*display: -webkit-box;*/
  /*-webkit-line-clamp: 2;*/
  /*overflow: hidden;*/
  /*text-overflow: ellipsis;*/
  /*-webkit-box-orient: vertical;*/
  margin: 0;
}

.haibao-box {
  padding-bottom: 40px;
  margin: 0.3rem 0.3rem 0;
  .small-img-box {
    padding-top: 72px;
    display: flex;
    /*justify-content: center;*/
    // width: 6.9rem;
    margin: auto;
    overflow-x: auto;

    div {
      display: flex;
      margin-right: 20px;
      padding-top: 5px;

      img {
        width: 156px;
        height: 200px;
        border: 2px solid transparent;
      }
    }

    div:last-child {
      margin-right: 0;
    }
  }

  .big-img {
    margin-top: 45px;
    display: flex;
    justify-content: center;

    img {
      width: 662px;
      height: 840px;
    }
  }

  p {
    color: #646464;
    font-size: 28px;
    margin: 80px auto 40px auto;
    width: 662px;
  }

  .btn {
    margin: 0 auto;
    width: 420px;
    height: 90px;
    background: rgba(255, 255, 255, 1);
    border-radius: 45px;
    border: 1px solid rgba(230, 230, 230, 1);
    font-size: 32px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 36px;
      height: 36px;
      margin-right: 16px;
    }
  }
}

.footer {
  padding: 12px;
  background: #fff;
  display: flex;
  align-items: center;
}

.footer .qr {
  width: 120px !important;
  height: 120px !important;
}

.footer .foter {
  width: 55%;
  margin-left: 0.1rem;
}

.footer .foter p {
  margin: 0;
  width: 100%;

  color: #999;
}

.footer .foter p span {
  border: 1px solid #999;
  display: inline-block;
  text-align: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 20px;
  margin-right: 10px;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 2px;
}

.haibao-box .px {
  /*color: #646464;*/
  /*width: 622px;*/
  /*margin: auto;*/
  /*margin-top: 102px;*/
  margin: auto;
  margin-bottom: 0.4rem;
  margin-top: 60px;
  width: 6.9rem;
  font-size: 0.28rem;
  font-weight: 400;
  line-height: 0.4rem;
  color: rgba(100, 100, 100, 1);
}

.kan {
  // width: 688px;
  // height: 872px;
  margin: auto;
  // margin-top: 30px;
  // margin-bottom: 102px;
  box-shadow: 0px 0px 23px 0px rgba(0, 0, 0, 0.1);
  border-radius: 13px;
}

.kan img {
  border-radius: 10px;
  display: block;
}

.activition {
  border: 2px solid #dd2b1e !important;
}
.activitionFour {
  padding: 1px;
}

::v-deep .van-swipe__indicator {
  background-color: #404040;
}
.van-swipe__indicators {
  top: 9.52rem;
}
.indicator {
  background-color: rgb(221, 43, 30);
  opacity: 1;
}
.showPop {
  width: 1.4rem;
  height: 1.34rem;
  position: absolute;
  float: left;
  display: inline-block;
  margin-top: -1.65rem;
  margin-left: 0.3rem;
  z-index: 1000;
}
.erCodeIs {
  width: 520px;
  margin-top: 50px;
  margin-left: 54px;
}
// .erCodeBOXOuter {
//   width: 7.22rem;
//   height: 6.86rem;
//   background: red;
// }
.erCodeBOX {
  width: 6.22rem;
  height: 6.22rem;
  background: white;
  border-radius: 0.2rem;
  margin: 264px auto 0;
  overflow: hidden;
}
.bottomFont {
  margin: -0.2rem 0px 0px !important;
  font-size: 0.3rem !important;
  font-family: PingFangSC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #616161 !important;
  line-height: 0.26rem !important;
  width: 100% !important;
  text-align: center;
}
.van-overlay {
  background: rgba(0, 0, 0, 0.5) !important;
}
.close {
  width: 60px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  margin-top: 60px;
}
.qrCodeStyle {
  padding: 50px;
  width: 520px;
}
.van-popup--bottom {
  z-index: 10000000000 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.van-popup {
  background-color: transparent;
}
.van-button {
  width: 90%;
  margin-bottom: 10px;
  border-radius: 10px;
  height: 52px;
}
.van-button--default {
  color: #007aff;
}
.van-button--normal {
  font-size: 20px;
}
</style>

